import { ProductionClass } from '../production.class';
import * as Constants from '../../globals/constants';
import { ResourceService } from '../../services/resource.service';
import { BuildingClass } from '../building.class';
import { PopulationService } from '../../services/population.service';
import { TechnologyService } from '../../services/technology.service';

/**
 * @internal
 * The isolateExtension allows the user to isolate current selection in the viewer.
 */
export class House extends BuildingClass {
  private populationPerMinute: number;
  private maxHousing: number;
  private totalPopulation: number;
  private canProduceAmmount: number;
  private setToMax = false;

  /**
   * @ignore
   */
  constructor(resourceService: ResourceService, populationService: PopulationService, technologyService: TechnologyService) {
    super(resourceService, populationService, technologyService);
    this.setMaxHousing();
    this.canProduceAmmount = 0;
    this.numberOfBuildings = 1;
    this.initBuilding('House', 'house', Constants.SETTINGS.BUILDING_SETTINGS.HOUSE);
    this.populationPerMinute = 60;
    this.totalPopulation = this.getMaxHousing();
  }

  public produce(timePassed) {
    if (this.canProduceAmmount <= 0 && this.totalPopulation < this.getMaxHousing()) {
      const neededFood = 5;
      if (this.resourceService.payResource({
        food: neededFood
      })) {
        this.canProduceAmmount = neededFood;
      }
    }

    if (this.canProduceAmmount > 0) {
      this.produced.population += ((this.populationPerMinute / 60000) * timePassed) * this.numberOfBuildings;
    }
  }

  public setResearchBonus() {
    this.setMaxHousing();
  }

  public resourcesProduced() {
    if (this.produced.population > 1) {
      let produced = Math.floor(this.produced.population);
      if (produced > this.canProduceAmmount) {
        produced = this.canProduceAmmount;
      }
      this.totalPopulation += produced;
      this.produced.population -= produced;
      this.canProduceAmmount -= produced;
    }


    if (this.totalPopulation > this.getMaxHousing()) {
      this.totalPopulation = this.getMaxHousing();
    }


    if (this.setToMax) {
      this.totalPopulation = this.getMaxHousing();
      this.setToMax = false;
    }

    this.resourceService.setResource('population', this.totalPopulation);
    this.populationService.setPopulation(this.totalPopulation);
  }

  private setMaxHousing() {
    this.maxHousing = 5;

    if (this.technologyService.state.brick_house) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.philosophy) {
      this.maxHousing += 1;
    }

    if (this.technologyService.state.fortification) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.higher_education) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.medication) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.colonies) {
      this.maxHousing += 3;
    }

    if (this.technologyService.state.workers_houses) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.high_rise) {
      this.maxHousing = Math.floor(this.maxHousing * 1.5);
    }

    if (this.technologyService.state.internet) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.arcology) {
      this.maxHousing += 4;
    }

    if (this.technologyService.state.moon_base) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.mars_base) {
      this.maxHousing += 2;
    }

    if (this.technologyService.state.space_base) {
      this.maxHousing += 2;
    }
    if (this.technologyService.state.terraforming) {
      this.maxHousing += 5;
    }
  }

  private getMaxHousing() {
    return this.maxHousing * this.numberOfBuildings;
  }

  public loadBuilding(amount) {
    super.loadBuilding(amount);
    this.setToMax = true;
  }

  public getBuildingImage() {
    if (this.technologyService.state.brick_house) {
      return 'https://i.pinimg.com/564x/75/b0/c0/75b0c082798d763add59f09fb17fddfa.jpg';
    } else {
      return super.getBuildingImage();
    }
  }
}
